import axiosClient from './config';

export const getDashboardStatsService = async (organization_uuid) => {
  return await axiosClient.get(`organisations/${organization_uuid}/dashboard/`);
};